export default __webpack_public_path__ + "static/media/FotoJavi.daed09c9.jfif";